import View from './MainNavigation'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const MainNavigation = connect(mapStateToProps)(View)

export default MainNavigation
